import React, {useEffect, useRef} from 'react';
import ReactDOM from 'react-dom';
import './BottomSheet.css';

type BottomSheetProps = {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
};

export const BottomSheet: React.FC<BottomSheetProps> = ({children, isOpen, onClose}) => {
  const el = useRef(document.createElement('div'));

  useEffect(() => {
    if (!isOpen) return;

    const currentEl = el.current;
    const modalElement = document.querySelector('#modal');

    if (!modalElement) {
      console.error('BottomSheet requires a DOM element with id="modal" to render into');
      return;
    }

    modalElement.appendChild(currentEl);
    document.body.classList.add('no-scroll');

    return () => {
      modalElement.removeChild(currentEl);
      document.body.classList.remove('no-scroll');
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="bottom-sheet__overlay" onClick={onClose}>
      <div className="bottom-sheet__content" onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>,
    el.current,
  );
};
